// Angular
import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
// Layout
import { LayoutConfigService, ToggleOptions, MachineService, MenuHorizontalService } from '../../../../core/_base/layout';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { Cache } from 'aws-amplify';

@Component({
	selector: 'kt-header-mobile',
	templateUrl: './header-mobile.component.html',
	styleUrls: ['./header-mobile.component.scss']
})
export class HeaderMobileComponent implements OnInit, AfterViewInit {
	// Public properties
	headerLogo: string;
	asideDisplay: boolean;

	machine: any = Cache.getItem('selected_machine');

	menuType = null;

	showMenu = false;

	menuObj = [];

	wholeMenuObj;

	qParams;

	routeValue;

	toggleOptions: ToggleOptions = {
		target: 'body',
		targetState: 'kt-header__topbar--mobile-on',
		togglerState: 'kt-header-mobile__toolbar-topbar-toggler--active'
	};

	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayoutConfigService
	 */
	constructor(private layoutConfigService: LayoutConfigService,
				private router: Router,
				public menuHorService: MenuHorizontalService,
				private cdr: ChangeDetectorRef,
				private route: ActivatedRoute,
				private machineService: MachineService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */

	ngAfterViewInit(): void {
		// const currUrl = this.router.url;
		// if (currUrl.startsWith('/machine/')) {
		// 	if (this.machine) {
		// 		this.showMenu = true;
		// 	}
		// } else {
		// 	this.showMenu = false;
		// }

		const currUrl = this.router;
		this.routeValue = currUrl;

		this.route.queryParams.subscribe(qParams => {
			this.qParams = qParams;
			this.checkForURL(this.routeValue);
		});

		this.cdr.detectChanges();
	}

	ngOnInit() {
		this.headerLogo = this.layoutConfigService.getStickyLogo();
		this.asideDisplay = this.layoutConfigService.getConfig('aside.self.display');

		this.machineService.selectedMachine$.subscribe(mId => {
			this.machine = mId;
			this.cdr.detectChanges();
		});


		this.menuHorService.menuList$.subscribe(vals => {
			this.wholeMenuObj = vals;
			if (vals && this.router.url) {
				this.checkForURL({ url: this.router.url });
				this.cdr.detectChanges();
			}
		});

		this.router.events.subscribe((value: any) => {
			if (value instanceof NavigationStart) {
				this.routeValue = value;
				this.checkForURL(this.routeValue);
			}
		});

		// Initial check for current route
		if (this.router.url && this.wholeMenuObj) {
			this.checkForURL({ url: this.router.url });
		}

		this.route.queryParams.subscribe(qParams => {
			this.qParams = qParams;
			if (this.routeValue && this.routeValue.url) {
				this.checkForURL(this.routeValue);
			} else if (this.router.url) {
				this.checkForURL({ url: this.router.url });
			}
		});






		// this.router.events.subscribe((value: any) => {
		// 	if (value instanceof NavigationStart) {
		// 		console.log('value.url',value.url);

		// 		if (value.url.startsWith('/machine/')) {
		// 			if (this.machine) {
		// 				this.showMenu = true;
		// 			}
		// 		} else {
		// 			this.showMenu = false;
		// 		}
		// 		this.cdr.detectChanges();

		// 	}
		// });
		// console.log('this.showMenu:VI:',this.showMenu);


	}

	checkForURL(value) {
		if (value && value.url) {
			if (value.url.startsWith('/machine/')) {
				const segments = value.url.split('/').filter(Boolean);
				const currentMachineId = segments[1] || null;
				if (this.machine || currentMachineId) {
					this.menuType = 'machine';
					this.menuObj = (this.wholeMenuObj && this.wholeMenuObj.machine && this.wholeMenuObj.machine.items) ? this.wholeMenuObj.machine.items : [];
					this.showMenu = true;
				}
			} else if (value.url.startsWith('/clients/')) {
				this.menuType = 'client';
				this.menuObj = (this.wholeMenuObj && this.wholeMenuObj.clients && this.wholeMenuObj.clients.items) ? this.wholeMenuObj.clients.items : [];
				this.showMenu = true;
			} else if (value.url.startsWith('/inventory/')) {
				this.menuType = 'inventory';
				this.menuObj = (this.wholeMenuObj && this.wholeMenuObj.inventory && this.wholeMenuObj.inventory.items) ? this.wholeMenuObj.inventory.items : [];
				this.showMenu = true;
			} else {
				this.menuObj = [];
				this.showMenu = false;
			}
		} else {
			this.menuObj = [];
			this.showMenu = false;
		}
		this.cdr.detectChanges();
	}

	onClick(){
		console.log("Menu btn clicked:");

	}


}
